import "./Home.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import Sekcja1Hero from "./sections/Sekcja1Hero";
import CuratedDigitalCollections from "./sections/CuratedDigitalCollections";
import SmartOfficeGadgets from "./sections/SmartOfficeGadgets";
import ViralTechDrops from "./sections/ViralTechDrops";
import EcosystemPartners from "./sections/EcosystemPartners";
import FooterHub from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PrimaryNavigation />
      <Sekcja1Hero />
      <CuratedDigitalCollections />
      <SmartOfficeGadgets />
      <ViralTechDrops />
      <EcosystemPartners />
      <FooterHub />
    </div>;
}